import { Link as ReachLink } from '@reach/router';
import styled from 'styled-components';

const Link = styled(ReachLink)`
   border-radius: 10px;
   width: 90%;
   max-width: 400px;
   background: ${({ theme }) => theme.primaryBlueLight};
   border: none;
   color: ${({ theme }) => theme.primaryWhite};
   margin: 0.8rem auto;
   position: relative;
   text-decoration: none;
   font-size: 1.2em;
   font-weight: 700;
   &:hover {
      cursor: pointer;
      background-color: ${({ theme }) => theme.primaryBlueDark};
      color: ${({ theme }) => theme.primaryWhite};
   }
`;

export default Link;
